<template>
  <div>
    <b-input-group>
      <b-input-group-prepend is-text>
        <feather-icon icon="SearchIcon" />
      </b-input-group-prepend>
      <b-form-input
        v-model="fieldModelValue"
        placeholder="Busca por el nombre del plan de estudios de tu interés"
      />

      <transition name="fade">
        <b-input-group-append
          v-if="fieldModelValue !== ''"
          is-text
          class="cursor-pointer"
          @click="() => fieldModelValue = ''"
        >
          <feather-icon
            icon="XIcon"
            class="text-danger"
            size="20"
          />
        </b-input-group-append>
      </transition>
    </b-input-group>
  </div>
</template>

<script>
import {
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
} from 'bootstrap-vue'

export default {
  components: {
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
  },
  props: {
    resultSize: {
      type: [Number, null],
      default: 0,
    },
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    fieldModelValue: {
      get() {
        return this.search
      },
      set(newValue) {
        this.search = newValue
        this.$emit('newSearch', newValue)
      },
    },
  },
}
</script>
